interface SectionTitleProps {
  title: string;
  subtitle?: string;
  containerClassName?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

export function SectionTitle({
  title,
  subtitle,
  containerClassName,
  titleClassName,
  subtitleClassName,
}: SectionTitleProps) {
  return (
    <div className={`flex flex-col gap-spacing-1 ${containerClassName}`}>
      <h3
        className={`text-palette-text-primary ${titleClassName || "h3-Medium"}`}
      >
        {title}
      </h3>
      {subtitle && (
        <p
          className={`text-palette-text-secondary paragraphs-Large-Medium ${subtitleClassName}`}
        >
          {subtitle}
        </p>
      )}
    </div>
  );
}
